<template>
    <section>
        <div class="container">        
            <CommonBreadcrumb class="bread_block_mod" /> 
        </div>

        <div class="container-fluid px-0">
            <div class="guide_block_banner">
                <div class="eng_guide_banner">
                    <picture>
                        <source width="1920" height="540" type="image/webp" srcset="~/assets/eng-guide/step_one/banner.webp">
                        <img height="540" width="1920" type="image/jpeg" src="~/assets/eng-guide/step_one/banner.jpg" alt="Average Engagement Ring Cost, Diamond Ring Cost">
                    </picture>
                    <div class="eng_guide_upper">
                        <h2>Step 1</h2>
                        <h6 class="font-active">Set A Budget</h6>
                        <p class="mb-0" v-if="$country.is_india">
                            The journey to finding the perfect engagement ring begins with setting a budget for your diamond engagement ring.
                        </p>
                        <p class="mb-0" v-else>The journey to finding the perfect engagement ring begins with setting a budget for your diamond engagement ring.</p>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="container-lg mt-5">
            <div class="guide_block pb-4">
                <h1 class="mb-3 font-active">average engagement ring cost</h1>
                <p v-if="$country.is_india">
                    Knowing how much you can spend on an <NuxtLink :to="localePath('/engagement-rings')">engagement ring</NuxtLink> to cover your engagement ring cost based on your financial situation will put you at ease when selecting your ring's diamond and ring setting.
                    <br><br>
                    Setting the budget will also give you an understanding of whether you must save money or not after browsing through potential ring options.
                    <br><br>
                    There is absolutely no average engagement ring cost when it comes to shopping for your ring. An average engagement ring cost does not exist, as prices can vary when shopping online based on the diamond and gold quality. And even if there was an average engagement ring cost, how could you possibly make your decision knowing that you were to shop for a ring based on your partner’s style and preference.
                    <br><br>
                    Your metal choice also determines the price of your <NuxtLink :to="localePath({ name:'cyo-setting-list-ring'})">ring setting</NuxtLink>. Choosing exquisite metals such as platinum or high-purity gold increases the overall budget. These two factors related to choosing your ring setting and metal purity change how you’d save or set your budget, even if there was an average engagement ring cost.
                    <br><br>
                    Besides the cost of the gold band, you will also have to consider the price of your diamond centre stone. <NuxtLink :to="localePath('/lab-diamonds')">Lab-grown diamonds</NuxtLink> do cost less, making your spending much more budget-friendly and significantly dropping the price of your engagement ring.
                    <br><br>
                    The bigger the size and the better the diamond quality chosen, the higher the price will be, thus raising your engagement ring cost. Hence, we always recommend that you decide how much to spend when buying an engagement ring to save on your average engagement ring cost.
                </p>
                <p v-else>
                    Knowing how much you can spend on an engagement ring to cover your engagement ring cost based on your financial situation will put you at ease when selecting your ring's diamond and ring setting. <br><br>
                    <NuxtLink :to="localePath('/blog/how-to-set-engagement-ring-budget')">Setting the budget</NuxtLink> shall also give you an understanding if you must save money or not after browsing through potential ring options. <br><br>
                    There is absolutely no average engagement ring cost when it comes to shopping for your ring. An average engagement ring cost does not exist as prices can vary when shopping online based on the diamond and gold quality. And even if there was an average engagement ring cost, how could you possibly make your decision knowing that you are to shop for a ring based on your partner’s style and preference. <br><br>
                    Your metal choice also determines the price of your <NuxtLink :to="localePath({ name:'cyo-setting-list-ring'})">ring setting</NuxtLink>. Choosing exquisite metals such as platinum or high purity gold increases the overall budget. These two factors related to choosing your ring setting and metal purity change how you’d save or set your budget even if there was an average engagement ring cost. <br><br>
                    Besides the cost of the gold band, you will also have to consider the price of your diamond center stone. 
                    <NuxtLink :to="localePath({ name:'loose-listing'})">Lab-grown diamonds</NuxtLink> do cost less, making your spending much more budget-friendly and significantly dropping the price on your engagement ring cost. <br><br>
                    The bigger the size and the better the diamond quality chosen, the higher the price shall be, thus raising your engagement ring cost. Hence we always recommend you decide how much to spend when buying an engagement ring to save of your average engagement ring cost.
                </p>
            </div>
           
            <div class="guide_block py-4">
                <h2 class="mb-3 font-active">Where to begin?</h2>
                <p v-if="$country.is_india">
                    It is quite possible that you may have come across the commonly stated guideline that you must follow the two-month salary rule and save up during this period before considering your engagement ring purchase. But how can this concept be true if there is no average engagement ring cost? It became a part of mainstream belief when diamonds were marketed to consumers in the 1940s. The diamond retailers of that time convinced consumers that saving two months’ pay was sufficient to buy a diamond ring, giving rise to the belief that an average engagement ring cost does exist.
                    <br><br>
                    But unlike those times, we live in a modern era where one can obtain a less-priced lab diamond engagement ring with the same sparkle and shine as that of mined stone rings. You could choose a lab diamond that is priced higher or lower based on your preferences. It could be a costly or a budget-friendly ring. But it would serve no purpose when you think of it from the perspective of there being an average engagement ring cost, as it all depends on your preferences.
                    <br><br>
                    An engagement ring is a symbolic representation of love; you should feel comfortable with how much you are willing to spend on creating the most significant jewellery piece of your life. The same can be said when shopping for wedding rings. Ultimately, it's about finding a budget-friendly engagement ring that resonates with you and your partner.
                </p>
                <p v-else>
                    It is quite possible that you may have come across the commonly stated guideline that you must follow the two-months salary rule and save up during this period before considering your engagement ring purchase. But how can this concept be true if there is no average engagement ring cost? It became a part of mainstream belief when diamonds were marketed to consumers in 1940’s. The diamond retailers of that time convinced consumers that saving two month’s pay was sufficient to buy a 
                    <NuxtLink :to="localePath({ name:'cyo-diamond-list-ring'})">diamond ring,</NuxtLink> giving rise to a belief that an average engagement ring cost does exist. <br><br>
                    But unlike those times, we live in a modern era where one can obtain a less priced <NuxtLink :to="localePath('/engagement-rings')">lab diamond engagement ring</NuxtLink> with the same sparkle and shine like that of mined stone rings. You could choose a lab diamond that is priced higher or priced lower based on your preferences. It could be a costly or a <NuxtLink :to="localePath('/blog/how-to-set-engagement-ring-budget')">budget friendly ring</NuxtLink>. But it would serve no basis for when you think of it from the perspective of there being an average engagement ring cost as it all depends on your preferences. <br><br>
                    An engagement ring is a symbolic representation of love; you should feel comfortable with how much you are willing to spend on creating the most significant {{ $t('jewelry') }} piece of your life. The same can be said when shopping for wedding rings. Ultimately it's about finding a budget friendly engagement ring that resonates with you and your partner.
                </p>
                <CommonStyleSlider />

            </div>
            
            <div class="guide_block py-4">
                <h2 class="mb-3 font-active">maximize your budget</h2>
                <p v-if="$country.is_india">When deciding your budget, you now have the liberty to explore engagement ring options that fit within the price range you can afford. There are ways to get the most out of your spending so that you own the ring you truly desire. Here are a few tips on how to make the most of your budget when taking your pick.</p>
                <p v-else>On deciding your budget, you now have the liberty to explore engagement ring options that fit within the price range you can afford. There are ways to get the most out of your spending so that you own the ring you truly desire. Here are a few tips on how to make the most of your budget when taking your pick.</p>
            </div>

            <div class="row guide_block align-items-center py-4">
                <div class="col-md-5 col-12 text-center">
                    <picture>
                        <source width="550" height="550" type="image/webp" srcset="~/assets/eng-guide/step_one/diamond_carat.webp">
                        <img loading="lazy" block class="my-3 radious_eight" height="550" width="550" type="image/jpeg" src="~/assets/eng-guide/step_one/diamond_carat.jpg" alt="Pick a diamond that is slightly less than the carat cutoff">
                    </picture>
                </div>

                <div class="col-md-7 col-12">
                    <h4 class="mb-3 font-active">Pick a diamond that is slightly less than the carat cutoff</h4>
                    <p v-if="$country.is_india">
                        You’d be surprised to know how much you can save when shopping for your diamond. Choosing a diamond slightly less than the standard carat weight cutoff is a great way to save on your spending. Instead of picking a <NuxtLink :to="localePath({ name: 'inspiration-1-ct'})">1 carat diamond</NuxtLink>, if you were to pick a 0.9 carat diamond, you would ultimately save a lot of dollars on your engagement ring purchase while not losing too much on the size of the diamond you desire.
                    </p>
                    <p v-else>
                        You’d be surprised to know how much you can save when shopping for your diamond.
                        Choosing a diamond slightly less than the standard carat weight cutoff is a great way to save on your spending. Instead of picking a <NuxtLink :to="localePath({ name: 'inspiration-1-ct'})">1-carat diamond,</NuxtLink> if you were to pick a 0.9 carat, you would ultimately save a lot of dollars on your engagement ring purchase while not losing too much on the size of the diamond you desire.
                    </p>
                    <NuxtLink class="radious_four" :to="localePath({ name:'loose-listing'})" >shop lab diamonds</NuxtLink>
                </div>
            </div>

            <div class="row guide_block align-items-center py-4 row_mod">
                <div class="col-md-7 col-12">
                    <h4 class="mb-3 font-active">When thinking of metal, think gold!</h4>
                    <p v-if="$country.is_india">
                        It is a known fact that platinum is one of the most precious metals available on the planet. It is also long-lasting and beautiful and it truly makes an engagement ring special. But all these features come with a cost and will significantly raise the amount you'd spend on your engagement ring.
                        <br><br>
                        When looking for a metal, we recommend going for gold. Gold costs less than platinum and is also more durable. The added benefit of choosing gold is that you also get to select multiple colours, such as white, yellow and rose, when it comes to this metal.
                        <br><br>
                        Gold also comes in multiple purity variants. 24KT gold is the purest form of gold. But it is so soft that it can be bent and is prone to scratches.
                        <br><br>
                        It has to be alloyed with other metals so that it is hard and can be used to create jewellery. These variants are 14KT and 18KT gold.
                    </p>
                    <p v-else>
                        It is a known fact that <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'platinum-engagement-rings' } })">platinum</NuxtLink> is one of the most precious metals available on the planet. It is also long-lasting and beautiful and truly makes an engagement ring special. But all these features come with a cost and shall significantly raise the amount you'd spend on your engagement ring.
                        <br><br>
                        When looking for a metal, we recommend going for gold. <NuxtLink :to="localePath('/blog/gold-vs-platinum-jewelry')">Gold costs less than platinum</NuxtLink> and is also more durable. The added benefit of choosing gold is that you also get to select multiple colors, such as <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'white-gold-engagement-rings' } })">white</NuxtLink>, <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'yellow-gold-engagement-rings' } })">yellow</NuxtLink>, and <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'rose-gold-engagement-rings' } })">rose</NuxtLink>, when it comes to this metal.
                        <br><br>
                        Gold also comes in multiple purity variants. 24KT gold is the purest form of gold. But it is so soft that it can be bent and prone to scratches.
                        <br><br>
                        It has to be alloyed with other metals so that it is hard and can be used to create {{ $t('jewelry') }}. These variants are 14KT and 18KT gold.
                    </p>
                    <NuxtLink class="radious_four" :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'white-gold-engagement-rings' } })">shop white gold rings</NuxtLink>
                </div>
                <div class="col-md-5 col-12 text-center">
                    <picture>
                        <source width="550" height="550" type="image/webp" srcset="~/assets/eng-guide/step_one/ring_metal.webp">
                        <img loading="lazy" block class="my-3 radious_eight" height="550" width="550" type="image/jpeg" src="~/assets/eng-guide/step_one/ring_metal.jpg" alt="When thinking of metal, think gold!">
                    </picture>
                </div>
            </div>

            <div class="row guide_block py-4 align-items-center">
                <div class="col-md-5 col-12 text-center">
                    <picture>
                        <source width="550" height="550" type="image/webp" srcset="~/assets/eng-guide/step_one/diamond_shape.webp">   
                        <img loading="lazy" block class="my-3 radious_eight" height="550" width="550" type="image/jpeg" src="~/assets/eng-guide/step_one/diamond_shape.jpg" alt="Choose fancy-shaped diamonds">
                    </picture>
                </div>
                <div class="col-md-7 col-12">
                    <h4 class="mb-3 font-active">Choose fancy-shaped diamonds</h4>
                    <p v-if="$country.is_india">
                        It is a known fact that almost seventy-five per cent of engagement rings crafted worldwide feature <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'round-cut-diamond' } })">round diamonds</NuxtLink> as they are traditional brilliant cuts with the grandest sparkle and shine. They are also priced comparatively higher than other fancy-shaped diamonds because of their high demand. But you need not go for it just because it is the most popular choice.
                        <br><br>
                        There are many shapes as beautiful as the round cut diamond. You can always pick a fancy-shaped diamond, like the trending oval cut this season or other fancy-shaped stones like the <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'princess-cut-diamond' } })">princess</NuxtLink>, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'cushion-cut-diamond' } })">cushion</NuxtLink> and other cuts to maximise savings and get the perfect-looking engagement ring. You just have to browse through the vast collection available and you're sure to find a diamond that'll catch your eye.
                    </p>
                    <p v-else>
                        It is a known fact that almost seventy-five percent of engagement rings crafted worldwide feature round diamonds as they are traditional brilliant cuts with the grandest sparkle and shine. They are also priced comparatively higher than other fancy shaped diamonds because of its high demand. But you need not go for it just because it is the most popular choice.
                        <br><br>
                        There are many shapes as beautiful as the 
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'round-cut-diamond' } })">round cut diamond.</NuxtLink> 
                        You can always pick a fancy-shaped diamond, like the trending oval cut this season, or other fancy-shaped stones like the princess, cushion, and other cuts to maximize savings and get the perfect-looking engagement ring. You just have to browse through the vast collection available, and you're sure to find a diamond that'll catch your eye.
                    </p>
                    <NuxtLink class="radious_four" :to="localePath({ name:'cyo-diamond-list-ring', params:{ start_with: 'oval-rings' } })">shop oval rings</NuxtLink>
                </div>
            </div>

            <div class="row guide_block align-items-center py-4 row_mod">
                <div class="col-md-7 col-12">
                    <h4 class="mb-3 font-active">Get a sparkling ring setting</h4>
                    <p v-if="$country.is_india">
                        When creating your diamond engagement ring, you might want to shop for a diamond that is not necessarily large, which is absolutely fine when you have a set budget. But you can always make the diamond appear larger by selecting the perfect ring setting. For example, choose a halo ring setting or a ring set with two smaller side diamonds to accentuate your centre diamond, making it appear larger.
                    </p>
                    <p v-else>
                        When creating your diamond engagement ring, you might want to shop for a diamond that is not necessarily large, which is absolutely fine when you have a set budget. But you can always make the diamond appear larger by selecting the perfect ring setting. For example, choose a <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'halo-engagement-rings' } })">halo ring setting</NuxtLink> or ring setting with two smaller side diamonds to accentuate your center diamond, making it appear larger.
                    </p>
                    <NuxtLink class="radious_four" :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'halo-engagement-rings' } })">shop halo rings</NuxtLink>
                </div>

                <div class="col-md-5 col-12 text-center">
                    <picture>
                        <source width="550" height="550" type="image/webp" srcset="~/assets/eng-guide/step_one/halo_ring.webp">
                        <img loading="lazy" block class="my-3 radious_eight" height="550" width="550" type="image/jpeg" src="~/assets/eng-guide/step_one/halo_ring.jpg" alt="Get a sparkling ring setting">
                    </picture>
                </div>
            </div>

            <div class="guide_block py-4">
                <h2 class="mb-3 font-active">Payment Plans</h2>
                <p v-if="$country.is_india">
                    At Friendly Diamonds, we offer multiple hassle-free payment options for your <NuxtLink class="view_all_cta" :to="localePath({ name:'shop-all' })">lab grown diamond jewellery</NuxtLink> purchases, all priced in Indian rupees (₹).  <br><br>
                    From credit/debit cards, including Visa, MasterCard, American Express and RuPay, to convenient telephonic assistance, our team ensures a seamless payment experience. If a transaction fails, our prompt notification system keeps you informed. For telephonic assistance, our executives will guide you through alternative payment methods. 
                </p>
                <p v-else>
                    At Friendly Diamonds, we offer a range of payment options to make your engagement ring purchase simple and easy.
                    You can pay for your ring via secure payment like PayPal via any golbally issued debit or credit cards. You can also choose to split your payments between multiple debit or credit cards. You can save on to 2% on your total cart value by paying via bank wire transfer.
                </p>
                <NuxtLink class="radious_four" :to="localePath('/customer-service/payment-options')">learn more</NuxtLink>
                <!-- <h5 class="mt-4">To make your engagement ring buy an easy process we at Friendly Diamonds have created an interest-free monthly payment scheme perfect for your purchase.</h5> -->
            </div>

            <div class="guide_block py-4" v-if="$country.accrue">
                <h4 class="mb-3 font-active">Save up & earn $ with Accrue Savings</h4>
                <p>Earn cash rewards towards your Friendly Diamonds’ purchase when you save up with Accrue Savings, a credit-free payment option.</p>
               
                <h5>How Does it work?</h5>
                <ul class="ps-4">
                    <li>Sign up for an Accrue Savings account in just a few minutes.</li>
                    <li>Choose how much you want to save up for and set up a savings plan with recurring deposits. Your money is always secure and you can make adjustments to your plan whenever you need to.</li>
                    <li> As you make progress towards your goal, you’ll earn cash rewards towards your purchase.</li>
                    <li>Want to reach your goal faster ? Make one-time deposits or invite friends and family to contribute via crowdfunding.</li>
                </ul>
                <h5>To be eligible, you will need to be able to :</h5>
                <ul class="ps-4">
                    <li>Provide bank account information to set up deposits to your savings plan.</li> 
                    <li>Verify that you are a US resident (Accrue is only available in the US at this time).</li>
                </ul>
                <p>For more information visit the <a rel="nofollow noopener" target="_blank" href="https://www.accruesavings.com/friendly-diamonds?utm_source=Friendly+Diamonds&utm_medium=Payment+Options">Accrue Savings</a> website.</p>
            </div>
            
            <div class="row cta_block">
                <div class="col-md-12 col-12 mx-auto px-0 d-flex align-items-center justify-content-center font-active">
                    <NuxtLink :to="localePath('/engagement-ring-guide')">
                        Engagement Ring Guide
                        <div class="arrow_eng">
                            <SvgHeaderSvg :type="'left'" /></div> Back
                    </NuxtLink>
                    <span>|</span>
                    <NuxtLink :to="localePath('/engagement-ring-guide/types-of-ring-settings')">
                        Next <div class="arrow_eng">
                            <SvgHeaderSvg :type="'right'" /></div> Choose Setting
                    </NuxtLink>
                </div>
            </div>
        </div>

    </section>
</template>

<script setup>
    const localePath = useLocalePath()
    const { $country } = useNuxtApp()
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>

<style scoped>
.arrow_eng svg.svg-head {
    height: 13px;
    width: 12px;
    margin: 0 10px;
}
.eng_guide_banner {
    position: relative;
}
.eng_guide_upper {
    position: absolute;
    top: 50%;
    left: 20%;
    width: 25%;
    transform: translate(-50%,-50%);
}
 .eng_guide_upper h2 {
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
}
.eng_guide_upper h6 {
    font-size: 32px;
    color: var(--green);
    font-weight: 500;
    text-transform: capitalize;
}
.eng_guide_upper h6 span{
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
    color: #000;
    display: block;
    font-family: Lato;
    margin-bottom: 2%;
}
.eng_guide_upper p {
    font-size: 14px;
    font-weight: 500;
    /* text-transform: capitalize; */
    color: #000;
    line-height: 1.8;
}
.eng_guide_flex {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.eng_guide_flex a {
    display: inline-block;
    font-size: 14px;
    padding: 1.5% 5%;
    color: #000;
    text-transform: unset;
    font-weight: 400;
    border: 1px solid #000;
}
/* -------cta */
.row.cta_block a {
    display: flex;
    align-items: center;
    color: #000;
    font-size: 18px;
}
.row.cta_block span {
    font-size: 25px;
    margin: 0 15px;
    font-weight: 300;
}
.row.cta_block {
    margin: 4% 0;
}
/* -------cta */
@media(max-width:1350px ){
    .eng_guide_upper{
        width: 50%;
        left: 30%;
    }
}
@media(max-width:1024px ){
    .eng_guide_upper h6 {
        font-size: 32px;
    }
    .eng_guide_banner img {
        height: 45vh;
        object-fit: cover;
        object-position: 100%;
    }
}
@media(max-width:992px ){
    .eng_guide_banner img{
        display: none;
    }
    .eng_guide_upper {
        width: 100%;
        left: 0;
        transform: unset;
        position: relative;
        top: 0;
    }
    .guide_block_banner {
        padding: 0 36px 5% 36px;
        border-bottom: 1px solid #ccc;
    }
     /* -------cta */
     .row.cta_block a {
        font-size: 16px;
    }
    /* -------cta */
}
@media(max-width:767px ){
    .arrow_eng {
        /* font-size: 40px; */
    }
    .eng_guide_upper h6 {
        font-size: 32px;
    }
    .guide_block_banner {
        padding: 0% 18px 8% 18px;
        border-bottom: 1px solid #ccc;
    }
    /* -------cta */
    .row.cta_block a {
        font-size: 14px;
    }
    /* -------cta */
}
/* -------------------------------------------------------------- */

.guide_block h2, .guide_block h1 {
    font-size: 32px;
    text-transform: capitalize;
    color: var(--green);
}
.guide_block h5 {
    font-size: 16px;
    font-weight: 600;
    color: #6a6161;
}

.guide_block h4 {
    font-size: 26px;
    text-transform: capitalize;
}
.guide_block h4 span{
    color: var(--green);
}
.guide_block p {
    font-size: 16px;
    color: #6a6161;
    font-weight: 500;
}
.guide_block h3 {
    font-size: 16px;
    font-weight: 600;
    color: var(--green);
}
.guide_block a {
    display: inline-block;
    font-size: 14px;
    padding: 10px 20px;
    color: #000;
    border: 1px solid #000;
    text-transform: uppercase;
    font-weight: 600;
}
.guide_block p a {
    background: none;
    padding: 0;
    font-size: 16px;
    text-transform: unset;
    color: #6a6161;
    font-weight: 500;
    border: 0;
    text-decoration: underline;
    color: var(--green);
}
.guide_block ul li {
    font-size: 16px;
    color: #6a6161;
    font-weight: 500;
}
@media(max-width: 992px){
    .guide_block h2, .guide_block h1 {
        font-size: 26px;
        margin-top: 4%;
    }
}

@media(max-width: 767px){
    .row_mod {
        flex-direction: column-reverse;
    }

    .guide_block h2, .guide_block h1{
        font-size: 24px;
        margin-top: 6%;
    }
    .guide_block h4{
        font-size: 24px;
    }
    .guide_block p {
        margin: 3% 0 !important;
    }
    .guide_block a {
        margin-top: 5%;
    }
    .guide_block h3 {
        font-size: 16px;
    }

}
</style>